import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const dietaryPreferencesBaseEndpoint = ENDPOINTS.DIETARYPREFERENCE;

// Event API using Catering Package endpoints
export const dietaryPreferenceApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["dietaryPreferences"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getDietaryPreferences: builder.query({
        query: (payload) => `${dietaryPreferencesBaseEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "dietaryPreferences" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),

      addDietaryPreference: builder.mutation({
        query: (requestData) => ({
          url: `${dietaryPreferencesBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "dietaryPreferences" }],
      }),
      updateDietaryPreference: builder.mutation({
        query: ({ id, requestData }) => ({
          url: `${dietaryPreferencesBaseEndpoint}/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "dietaryPreferences" }],
      }),
      deleteDietaryPreferences: builder.mutation({
        query: (id) => ({
          url: `${dietaryPreferencesBaseEndpoint}/${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "dietaryPreferences" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useAddDietaryPreferenceMutation,
  useGetDietaryPreferencesQuery,
  useUpdateDietaryPreferenceMutation,
  useDeleteDietaryPreferencesMutation,
} = dietaryPreferenceApi;
